import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const PostalCode = (props) => {
  return (
    <FormGroup controlId="postalCode">
      <Col componentClass={ControlLabel} sm={5}>
        Postal Code
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.postalCode} onChange={props.handleChangePostalCode}
          autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

PostalCode.propTypes = {
  postalCode: PropTypes.string,
  handleChangePostalCode: PropTypes.func
};

export default PostalCode;



// WEBPACK FOOTER //
// ./src/app/components/postalCode/PostalCode.js